// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"Tabs_tabsWrapper__N5bYn","tabButton":"Tabs_tabButton__WZNsI","active":"Tabs_active__DJc-T"};